import { render, staticRenderFns } from "./riderWiseOFDReport_KSA.vue?vue&type=template&id=10d07592&"
import script from "./riderWiseOFDReport_KSA.vue?vue&type=script&lang=js&"
export * from "./riderWiseOFDReport_KSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports